var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vue-search-bar-toggle"},[_c('button',{attrs:{"aria-expanded":_vm.open ? 'true' : 'false',"aria-controls":"search-bar"},on:{"click":_vm.handleClick}},[_vm._v("\n        "+_vm._s(_vm.translations.searchText)+"\n    ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }